import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';

@Component({
  selector: 'px-see-more-less-button',
  template: `
    <mx-text-button [label]="expanded ? 'See less' : 'See more'" [endIcon]="expanded ? 'remove' : 'add'" [enabled]="enabled"/>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TextButtonComponent]
})
export class SeeMoreLessButtonComponent {
  @Input({required: true}) public expanded: boolean;
  @Input() public enabled: boolean = true;
}
